import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column ;
  align-items: center;
  flex: 1;
`;

export const Title = styled.p`
  color: #10264a;
  font-size: 24px;
  margin-top: 200px ;
  font-weight: 600 ;
`;

export const Subtitle = styled.p`
  color: #10264a;
  font-size: 16px;
`;
